module.exports = __webpack_public_path__ + "img/autospin_btn.352a5f47.png";